export default __webpack_public_path__ + "static/media/bglogo.509c4d0b.svg";